import Container from "@bmi-digital/components/container";
import CTACard from "@bmi-digital/components/cta-card";
import Grid from "@bmi-digital/components/grid";
import { graphql } from "gatsby";
import React from "react";
import DefaultImage from "@bmi-digital/components/resources/DefaultImage";
import { useTheme } from "@mui/material/styles";
import { useSiteContext } from "./Site";
import { getCTA } from "./link/utils";
import { OverlapCardsSection, StyledGrid } from "./styles/OverlapCardsStyles";
import createImageProps from "./image/createImageProps";
import createVideoProps from "./video/createVideoProps";
import {
  ContactUsPageInfoCard,
  DocumentLibraryPageInfoCard,
  SimplePageInfoCard
} from "./PageInfo";
import type { DefinedOverlapCards } from "../templates/home-page";

export type OverlapCard =
  | ContactUsPageInfoCard
  | SimplePageInfoCard
  | DocumentLibraryPageInfoCard;

const IntegratedOverlapCards = ({
  data
}: {
  // NOTE: Minimum two cards required.
  data: DefinedOverlapCards;
}) => {
  const { countryCode } = useSiteContext();
  const theme = useTheme();
  return (
    <OverlapCardsSection data-testid="overlap-cards-wrapper">
      <Container>
        <Grid spacing={3} container justifyContent="center">
          {data.map((card, key) => {
            const cardTitle = card.title || ""; // TODO: DXB-7055 title can't be null
            const cta = getCTA(card, countryCode, cardTitle);
            return (
              <StyledGrid key={key} xs={12} sm={6} md={5} lg={3}>
                <CTACard
                  title={cardTitle}
                  media={
                    "featuredVideo" in card && card.featuredVideo
                      ? createVideoProps(
                          {
                            ...card.featuredVideo,
                            "data-testid": "overlap-cards-video"
                          },
                          theme
                        )
                      : ("featuredMedia" in card &&
                          card.featuredMedia &&
                          createImageProps(
                            {
                              ...card.featuredMedia,
                              "data-testid": "overlap-cards-image"
                            },
                            theme
                          )) || { component: DefaultImage }
                  }
                  {...cta}
                  data-testid="overlap-card"
                />
              </StyledGrid>
            );
          })}
        </Grid>
      </Container>
    </OverlapCardsSection>
  );
};

export default IntegratedOverlapCards;

export const query = graphql`
  fragment OverlapCardFragment on PayloadPromoOrPageValue {
    ...PromoCardFragment
    ...PageInfoCardFragment
  }
`;
